// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CrownTwoToneSvg from "@fishx/icons-svg/es/asn/CrownTwoTone";
import FishxIcon from '../components/FishxIcon';

var CrownTwoTone = function CrownTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CrownTwoToneSvg
  }));
};

CrownTwoTone.displayName = 'CrownTwoTone';
export default React.forwardRef(CrownTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CrownTwoTone.js
// module id = 2354
// module chunks = 0